// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1a19167a","109":"dd20b12f","132":"6f8e5fd8","453":"5dfb63d7","559":"c76ef304","607":"67e49457","624":"1cd45b40","685":"d76eeb29","926":"383085f5","928":"bdb8223e"}[chunkId] + ".chunk.js";
};